
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Components/Header/Header';
import LandingPage from './Components/LandingPage/LandingPage';
import Roadmap from './Components/Roadmap/Roadmap';
import Ecosystem from './Components/Ecosystem/Ecosystem';

import FAQ from './Components/FAQ/FAQ';
import Footer from './Components/Footer/Footer';
import { Toaster } from 'react-hot-toast';
import Stake from './Components/Stake/Stake';
import StakingCard1 from "./Components/Pool_sec/StakingCard1";
import StakingCard2 from "./Components/Pool_sec/StakingCard2";
import StakingCard3 from "./Components/Pool_sec/StakingCard3";
import SwapCard from './Components/Swap/swapCard';
import IpcSwapCard from './Components/IpcSwap/IpcSwapCard';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster />
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <LandingPage />
              <Ecosystem />
             
              <Roadmap />
              
              <FAQ />
            </>
          } />
          
          <Route
            path="/Mining"
            element={
              <>
                <div>
                  {" "}
                  <h1 className="mt-3 mb-3 text-white text-center">
                    Earn USDT by IP 
                  </h1>
                </div>
                <div
                  className="d-flex flex-wrap justify-content-center gap-4 p-4"
                  style={{ backgroundColor: "#000" }}
                >
                  <StakingCard1 />
                  <StakingCard2 />
                  <StakingCard3 />
                </div>
                <Stake />
              </>
            }
          />
          <Route
            path="/swap"
            element={
              <>
                <div>
                  {" "}
                  <h1 className="mt-3 mb-3 text-white text-center">
                    Swap Old IP token to New IP token
                  </h1>
                </div>
                <div
                  className="d-flex flex-wrap justify-content-center gap-4 p-4"
                  style={{ backgroundColor: "#000" }}
                >
                  <SwapCard />
                </div>
              </>
            }
          />
          <Route
            path="/ipcswap"
            element={
              <>
                <div>
                  {" "}
                  <h1 className="mt-3 mb-3 text-white text-center">
                    IPC Swap: IP Asset to IP Classic
                  </h1>
                </div>
                <div
                  className="d-flex flex-wrap justify-content-center gap-4 p-4"
                  style={{ backgroundColor: "#000" }}
                >
                  <IpcSwapCard />
                </div>
              </>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;